// extracted by mini-css-extract-plugin
module.exports = {"tablePagination":"-paginated-table-tablePagination-1vZTBn-"};